import { useDocumentDetails } from 'hooks/useDocumentDetails';
import type { Document } from 'types';
import type { AccessibilityCompliance } from 'types/Documents';

export const useAccessibilityCompliance = (id: string | undefined) => {
  return useDocumentDetails<Document<AccessibilityCompliance> | undefined>(id ?? null);
};
